export const ONBOARDED = "Onboarded";
export const OTP_VERIFICATION_PENDING = "Otp Verification Pending";
export const CONTAINER_CONFIGURATION_PENDING =
  "Container Configuration Pending";
export const CONTAINER_CREATION_PENDING = "Container Creation Pending";
